// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const gardevoir: PokeData = {
  "id": 282,
  "name": "gardevoir",
  "height": 16,
  "weight": 484,
  "base_experience": 233,
  "types": [
    PokeType.PSYCHIC,
    PokeType.FAIRY
  ],
  "api_moves": [
    "growl",
    "psybeam",
    "confusion",
    "psychic",
    "hypnosis",
    "teleport",
    "double-team",
    "recover",
    "dream-eater",
    "charm",
    "future-sight",
    "wish",
    "imprison",
    "magical-leaf",
    "calm-mind",
    "healing-wish",
    "aura-sphere",
    "captivate",
    "stored-power",
    "heal-pulse",
    "disarming-voice",
    "draining-kiss",
    "misty-terrain",
    "moonblast",
    "mystical-fire",
    "dazzling-gleam",
    "life-dew"
  ],
  "moves": [
    "growl",
    "psychic",
    "future-sight",
    "calm-mind",
    "healing-wish",
    "misty-terrain",
    "moonblast",
    "dazzling-gleam",
    "life-dew",
    "prismatic-cage",
    "spirit-break",
    "guardian-bond",
    "psychic-terrain"
  ],
  "evolution_chain": {
    "id": 140,
    "item": null,
    "species": [
      {
        "name": "ralts",
        "order": 305,
        "types": [
          PokeType.PSYCHIC,
          PokeType.FAIRY
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "kirlia",
        "order": 306,
        "types": [
          PokeType.PSYCHIC,
          PokeType.FAIRY
        ],
        "evolves_from_species_id": 280,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 20,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "gardevoir",
        "order": 307,
        "types": [
          PokeType.PSYCHIC,
          PokeType.FAIRY
        ],
        "evolves_from_species_id": 281,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 30,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "gallade",
        "order": 308,
        "types": [
          PokeType.PSYCHIC,
          PokeType.FIGHTING
        ],
        "evolves_from_species_id": 281,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": {
              "name": "dawn-stone"
            },
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.USE_ITEM
            },
            "gender": {
              "name": "male"
            }
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 111,
    "speed": 113,
    "ability_power": 176
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
